import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TypeKeyListApi } from '../../types/common.type';
import { ButtonNavigationInterface, ModuleItemInterface } from '../../types/home.type';
import ListHorizontal from './ListHorizontal';
import MovieSection from './MovieSection';
import BannerSection from './sections/BannerSection';
import BlockLabelSection from './sections/BlockLabelSection';
import ChatHomeSection from './sections/ChatHomeSection';
import GridSection from './sections/GridSection';
import PostTypeSliderSection from './sections/PostTypeSliderSection';
import SpaceSection from './sections/SpaceSection';
import TabsWithListSection from './sections/TabsWithListSection';
import VerticalListSection from './sections/VerticalListSection';

interface AppListHomeProps {
  data: ModuleItemInterface[];
}

const AppListHome: React.FC<AppListHomeProps> = ({ data }) => {
  const navigation= useNavigate();
  const { lang } = useParams<{ lang: string }>(); // Retrieve lang from URL
  const { i18n } = useTranslation(); // Get i18n for fallback language
  
  const handleClick = (button: ButtonNavigationInterface) => {
    // Check if lang exists, otherwise use i18n current language as fallback
    const currentLang = lang || i18n.language || 'vi';
    const path = `/${currentLang}/list`; // Include lang in the path
    navigation(path, { state: button}); // Pass item in state
  };
  return (
    <div className="app-list-home">
      {data.map((module) => {
        switch (module.type) {
          case TypeKeyListApi.BANNER:
            return <BannerSection key={module.id} module={module} />;
          case TypeKeyListApi.LIST_HORIZONTAL:
            return (
              <ListHorizontal 
                key={module.id}
                title={module.label||""}
                movies={Array.isArray(module.items) ? module.items : []}
                type={module.button?.type || "lists"}
                posttype={module?.posttype || "movie"}
                api={module.button?.data?.api || "/posts/lists/movie/"}
                onClickViewMore={() => {
                  const currentLang = lang || i18n.language || 'vi';
                  if (module.button?.type === "linkpage") {
                    handleClick(module.button);
                  } else {
                    navigation(`/${currentLang}/list/${module.posttype}/lists`, { state: {
                        ...module.button,
                    }});
                  }
                }}
                
              />
            );
          case TypeKeyListApi.LIST_SLIDER:
            return (
              <MovieSection
                key={module.id}
                title={module.label||""}
                categories={Array.isArray(module.items) ? module.items : []}
                type={module.button?.type || "lists"}
                posttype={module?.posttype || "movie"}
                api={module.button?.data?.api || "/posts/lists/movie/"}
                iconUrl={module.images || ''}
                onClickViewMore={() => {
                  const currentLang = lang || i18n.language || 'vi';
                  if (module.button?.type === "linkpage") {
                    handleClick(module.button);
                  } else {
                    navigation(`/${currentLang}/list/${module.posttype}/lists`, { state: { api: module.button?.data?.api } });
                  }
                }}
               
              />
            );
          case TypeKeyListApi.LIST_VERTICAL:
            return <VerticalListSection key={module.id} module={module} />;
          case TypeKeyListApi.ITEM_GRID:
            return (
              <GridSection  
                key={module.id}
                title={module.label||""}
                movies={Array.isArray(module.items) ? module.items : []}
                type={module.button?.type || "lists"}
                posttype={module?.posttype || "movie"}
                api={module.button?.data?.api || "/posts/lists/movie/"}
                iconUrl={module.images || ''}
                onClickViewMore={() => {
                  const currentLang = lang || i18n.language || 'vi';
                  if (module.button?.type === "linkpage") {
                    handleClick(module.button);
                  } else {
                    navigation(`/${currentLang}/list/${module.posttype}/lists`, { state: { api: module.button?.data?.api } });
                  }
                }}
              />
            );
          // case TypeKeyListApi.TYPE_TABS:
          //   return <TabsSection key={module.id} module={module} />;
          case TypeKeyListApi.BLOCK_LABEL:
            return <BlockLabelSection key={module.id} module={module} />;
          case TypeKeyListApi.SPACE:
            return <SpaceSection key={module.id} module={module} />;
          case TypeKeyListApi.CHAT_HOME:
            return <ChatHomeSection key={module.id} module={module} />;
          case TypeKeyListApi.POST_TYPE:
            return <PostTypeSliderSection key={module.id} module={module} />;
          case TypeKeyListApi.LIST_ITEM_TAB:
            return <TabsWithListSection key={module.id} module={module} />;
          default:
            return null;
        }
      })}
    </div>
  );
};

export default AppListHome;
